import React from 'react'
import { PutAwayProvider } from '../../components/PutAway/provider/PutAwayProvider'
import { StepperPutAway } from '../../components/PutAway/screens/StepperPutAway/StepperPutAway'

export const PutAwayPage = () => {
  return (
    <PutAwayProvider>
      <StepperPutAway />
    </PutAwayProvider>
  )
}
